import { defer } from 'lodash';
import React from 'react';

import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useIsMobile } from '../../../../data/hooks/ui/useIsMobile';
import Icon from '../../../elements/icons/Icon';
import Link from '../../../elements/Link';

const EventExhibitorsMapButton = (props) => {
    const { event, isActive } = props,
        i18n = useI18n(),
        isMobile = useIsMobile();

    const handleOpenExhibitorsMap = () => {
        if (isMobile) {
            // there are some map related actions that run when the map route changes, so we want to run after all that
            defer(() => {
                app.store.dispatch(app.actions.ui.sidePanel.maximize(true));
            });
        }
    };

    if (!event.exhibitors_map_url) return null;

    return (
        <Link
            className={isActive ? 'is-active' : ''}
            href={['/events', event.id, 'exhibitors'].join('/')}
            onClick={handleOpenExhibitorsMap}
        >
            <Icon size={24} src={`img/event_map.png`} color="white" />
            {event.settings.exhibitors_map_label || i18n['label.exhibitors']}
        </Link>
    );
};

export default EventExhibitorsMapButton;
